import { LocalPrintshop } from '@mui/icons-material';
import { Button, Tooltip, type ButtonProps } from '@mui/material';


/** Shared Print button used on All Ledgers report and Ledger transaction modal. */
export const LedgerPrintButton = ({
  disabled = false,
  ...rest
}: ButtonProps) => (
  <Tooltip title="Print" arrow>
    <span>
      <Button
        {...rest}
        disableRipple
        disableElevation
        variant="outlined"
        disabled={disabled}
        sx={{
          fontSize: { xs: '9px', sm: '10px' },
          border: '1px solid',
          borderColor: 'bodyGray.main',
          boxShadow: `
                        inset 0 0 0.5px 1px hsla(0, 0%, 100%, 0.075),
                        0 0 0 1px hsla(0, 0%, 0%, 0.05),
                        0 0.3px 0.4px hsla(0, 0%, 0%, 0.02),
                        0 0.9px 1.5px hsla(0, 0%, 0%, 0.045),
                        0 3.5px 6px hsla(0, 0%, 0%, 0.09)
                      `,
          minWidth: { xs: '12px', sm: '15px', md: '25px' },
          height: { xs: '26px', sm: '30px' },
          backgroundColor: '#f9f9fe',
          ...(rest.sx || {}),
        }}
      >
        <LocalPrintshop sx={{ fontSize: { xs: '18px', sm: '24px' } }} />
      </Button>
    </span>
  </Tooltip>
);
